import { Devices as DevicesApi, useAuth } from "@app/shared";
import { FC, useMemo } from "react";
import { useFetch } from "../../hooks";
import { DashboardLayout } from "../layouts";
import { DevicesTable } from "../shared";
import { getLastTargetsForDevices } from "@app/shared/src/api/TargetControllerClient.gen";
import { WizardProgressDialog } from "./wizard/components/WizardProgressDialog";

export const Devices: FC = (props) => {
    const { currentOrganizationId } = useAuth();
    const [devices, , devicesHelper] = useFetch(() => DevicesApi.getByOrganizationId(currentOrganizationId), [currentOrganizationId]);
    const [lastTargets] = useFetch(() => getLastTargetsForDevices(devices?.map((d) => d.id!)), [devices]);

    // Only the device list gates the table. The last-target lookup fills in a single column, so
    // holding the whole grid behind it just makes the page feel slow for no extra information.
    const showLoading = useMemo(() => {
        return !!devicesHelper.isLoading;
    }, [devicesHelper.isLoading]);

    return (
        <DashboardLayout centerChildren={"Devices"}>
            <WizardProgressDialog />
            {devices?.length === 0 ? <h3>No Devices found</h3> : <DevicesTable devices={devices} isLoading={showLoading} lastTargets={lastTargets} onChange={() => devicesHelper.refreshData()} />}
        </DashboardLayout>
    );
};
